import { InjectionToken } from '@angular/core';

import type { Subject } from 'rxjs';

type ModalData = Record<string, unknown> & {
  close$: Subject<unknown>;
};

const MODAL_DATA = new InjectionToken<ModalData>('ModalService token');

export type { ModalData };
export { MODAL_DATA };
